
import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    useDisclosure,
    Box,
    CloseButton,
    Button,
} from '@chakra-ui/react'
function CompExample() {
    const {
      isOpen: isVisible,
      onClose,
      onOpen,
    } = useDisclosure({ defaultIsOpen: true })
  
    return isVisible ? (
      <Alert status='info'>
        <AlertIcon />
        <Box>
          <AlertTitle>If you have an employer account</AlertTitle>
          <AlertDescription>
          To manage commercial-related emails, go to Unsubscribe from all commercial emails under <span className='underline text-blue-600'>Email Settings.</span> 
          </AlertDescription>
        </Box>
        <CloseButton
          alignSelf='flex-start'
          position='relative'
          right={-1}
          top={-1}
          onClick={onClose}
        />
      </Alert>
    ) : (
      <Button onClick={onOpen}>Show Alert</Button>
    )
  }
  export default CompExample;